module.exports = __webpack_public_path__ + "img/money-from-bracket.7b3eb74b.svg";